import axios from "axios";
import { logout } from "../lib/auth";
import { incentiveTableColumn } from "../config/incentive";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// インセンティブ一覧
export async function getIncentives(props: { [key: string]: number | string }) {
  try {
    const path = "incentives";
    const params = makeParams(incentiveTableColumn.dataColumn, props);
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return null;
    }
    const incentives: dataDifine[] = response.data.fetch_data;
    const countIncentives: string = response.data.count_data;
    return { incentives, countIncentives };
  } catch (error) {
    // logout();
  }
}

// インセンティブ詳細
export async function getIncentive(id: string) {
  try {
    const path = "incentive";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    return response.data.detail_data[0];
  } catch (error) {
    // logout();
    return { option_data: [] };
  }
}

// インセンティブ編集
export async function putIncentive(editData: EditDataDifine) {
  try {
    const path = "incentive";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
    };
    const response = await axios.put(CONST.apiUrl + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// インセンティブ登録
export async function postIncentive(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "incentive";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}
